var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bl-color noselect pointer",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "8px"
    },
    on: {
      "click": _vm.openDietyPopup
    }
  }, [_vm._v(" + pridať ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }